import { render, staticRenderFns } from "./form-container.vue?vue&type=template&id=071778ef&"
import script from "./form-container.vue?vue&type=script&lang=js&"
export * from "./form-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports